/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 20th 2023, 7:19:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Stack from "@mui/material/Stack";
import { SubscriptionPlan } from "saas-subscription/schemas";
import { OSActionButton } from "ui-widgets";
import { UpgradeModal } from "./UpgradeModal";

interface IUpgradeAlertProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  upgradeTo: SubscriptionPlan["metadata"]["product_code"][];
}

export const UpgradeAlert = ({ message, title, upgradeTo }: IUpgradeAlertProps) => {
  return (
    <>
      <Alert severity="success" icon={<AutoAwesomeIcon />} classes={{ message: "plan-upgrade-alert-message" }}>
        <AlertTitle>{title || <>Time to Upgrade</>}</AlertTitle>
        <Stack direction="row" justifyContent="space-between">
          <div style={{ paddingRight: 20 }}>
            {message || (
              <>
                Looks like you need to upgrade to access this feature. Start enjoying extra features with an upgraded
                plan.
              </>
            )}
          </div>
          <UpgradeModal
            toShowCodes={upgradeTo}
            renderOpenButton={({ handleOpen }) => (
              <OSActionButton variant="contained" color="success" size="medium" onClick={handleOpen}>
                Upgrade
              </OSActionButton>
            )}
          />
        </Stack>
      </Alert>
    </>
  );
};
